import { render } from "./HowToStep.vue?vue&type=template&id=30dc1ac3"
import script from "./HowToStep.vue?vue&type=script&lang=js"
export * from "./HowToStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__